import { render, staticRenderFns } from "./StatementsReportDedicated.vue?vue&type=template&id=0785c336"
import script from "./StatementsReportDedicated.vue?vue&type=script&lang=js"
export * from "./StatementsReportDedicated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports